<template>
    <div>
        <v-snackbar v-for="msg in messages" :key="msg.id"
            :top="true"
            :timeout="msg.timeout"
            :color="msg.color"
            :multi-line="true"
            v-model="msg.show">
            {{ msg.message }}
            <v-btn light flat icon @click="msg.show = false">
                <v-icon>clear</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
export default {
    name: 'pad-message',
    computed: {
        messages() {
            return this.$store.getters['msg/messages']
        }
    }
}
</script>
